import gql from 'graphql-tag'

export const GET_AUTHORS = gql`
  query authors(
    $first: Int,
    $last: Int,
    $before: String,
    $after: String,
    $isDeleted: Boolean,
    $isCompleted: Boolean,
    $id: String,
    $idList: [String],
    $originId: String,
    $originIdList: [String],
    $fullname: String
  ) {
    authors(
      first: $first
      last: $last
      before: $before
      after: $after
      isDeleted: $isDeleted
      isCompleted: $isCompleted
      id: $id
      id_list: $idList
      originId: $originId
      originId_list: $originIdList
      fullname: $fullname
    ) {
      edges {
        node {
          id
          fullname
          email
          website
          biography
          profession
          facebook
          instagram
          twitter
          linkedin
          telegram
          tiktok
          imageAsset {
            path
            urlWithProtocol
          }
        }
      }
    }
  }
`